const REGULAR_TYPE = 1;
const VACATION_TYPE = 2;
const ITP_TYPE = 3;
const ITP_TAX_TYPE = 4;
const EXPENSE_TYPE = 5;
const EXPENSE_TRAVEL_TYPE = 6;
const SICK_PAYMENT_TYPE = 7;
const KRONOFOGDEN_PAYMENT_TYPE = 8;
const TRAVEL_ALLOWANCE_PAYMENT_TYPE = 9;

export default {
  REGULAR_TYPE,
  VACATION_TYPE,
  ITP_TYPE,
  ITP_TAX_TYPE,
  EXPENSE_TYPE,
  EXPENSE_TRAVEL_TYPE,
  SICK_PAYMENT_TYPE,
  KRONOFOGDEN_PAYMENT_TYPE,
  TRAVEL_ALLOWANCE_PAYMENT_TYPE
};



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/salaries/salary-type-constants.js
 **/